'use strict';

angular.module('ringbaPortal.services').factory('comparisonTypeService', comparisonTypeService);

function comparisonTypeService(_) {
  'ngInject';

  const _comparisonTypes = [
    { key: 'EQUALS', value: 'EQUALS', isNegativeMatch: false, forGeoTags: true, forBulkTags: false, forMultipleValues: false },
    { key: 'IN', value: 'DOES_NOT_EQUAL', isNegativeMatch: true, forGeoTags: true, forBulkTags: false, forMultipleValues: false },
    { key: 'EQUALS', value: 'DOES_NOT_EQUAL', isNegativeMatch: true, forGeoTags: false, forBulkTags: false, forMultipleValues: false },
    { key: 'CONTAINS', value: 'CONTAINS', isNegativeMatch: false, forGeoTags: false, forBulkTags: true, forMultipleValues: false },
    { key: 'CONTAINS', value: 'DOES_NOT_CONTAIN', isNegativeMatch: true, forGeoTags: false, forBulkTags: true, forMultipleValues: false },
    { key: 'BEGINS_WITH', value: 'BEGINS_WITH', isNegativeMatch: false, forGeoTags: false, forBulkTags: true, forMultipleValues: false },
    { key: 'BEGINS_WITH', value: 'DOES_NOT_BEGIN_WITH', isNegativeMatch: true, forGeoTags: false, forBulkTags: true, forMultipleValues: false },
    { key: 'GREATER_THAN', value: 'GREATER_THAN', isNegativeMatch: false, forGeoTags: false, forBulkTags: true, forMultipleValues: false },
    { key: 'LESS_THAN', value: 'LESS_THAN', isNegativeMatch: false, forGeoTags: false, forBulkTags: true, forMultipleValues: false },
    { key: 'EQUALS', value: 'EQUALS_SINGLE_VALUE', isNegativeMatch: false, forGeoTags: false, forBulkTags: true, forMultipleValues: false },
    { key: 'EQUALS', value: 'EQUALS_MULTIPLE_VALUES', isNegativeMatch: false, forGeoTags: false, forBulkTags: true, forMultipleValues: true },
    { key: 'EQUALS', value: 'DOES_NOT_EQUAL_SINGLE_VALUE', isNegativeMatch: true, forGeoTags: false, forBulkTags: true, forMultipleValues: false },
    { key: 'EQUALS', value: 'DOES_NOT_EQUAL_MULTIPLE_VALUES', isNegativeMatch: true, forGeoTags: false, forBulkTags: true, forMultipleValues: true },
    { key: 'EQUALS', value: 'DOES_NOT_EQUAL_MULTIPLE_VALUES', isNegativeMatch: true, forGeoTags: false, forBulkTags: true, forMultipleValues: false },
    { key: 'EQUALS', value: 'EQUALS_MULTIPLE_VALUES', isNegativeMatch: false, forGeoTags: false, forBulkTags: true, forMultipleValues: false },
    { key: 'EXISTS', value: 'EXISTS', isNegativeMatch: false, forGeoTags: false, forBulkTags: true, forMultipleValues: false },
    { key: 'EXISTS', value: 'DOES_NOT_EXIST', isNegativeMatch: true, forGeoTags: false, forBulkTags: true, forMultipleValues: false }
  ];

  const service = {
    comparisonTypes: _comparisonTypes,
    defaultComparisonType: _comparisonTypes[9],
    convertComparisonTypes: _convertComperisonTypes,
    getDefaultBulkTagComparison: getDefaultBulkTagComparison,
    isBulkTagComparison: isBulkTagComparison,
    getMultipleBulkTagComparison: getMultipleBulkTagComparison,
    getMultipleBulkTagComparisonSwitch: getMultipleBulkTagComparisonSwitch,
    getGeoTagComparison: getGeoTagComparison,
    showDropdownValues: showDropdownValues
  };

  return service;

  function _convertComperisonTypes(filters) {
    if (!filters || !filters.length) {
      return filters;
    }

    for (let i = 0; i < filters.length; i++) {

      if (!filters[i].tagCriteria || !filters[i].tagCriteria.length) {
        continue;
      }

      for (let j = 0; j < filters[i].tagCriteria.length; j++) {
        filters[i].tagCriteria[j] = _convertComperisonType(filters[i].tagCriteria[j]);
      }
    }

    return filters;
  }

  function _convertComperisonType(filter) {
    filter.comparisonTypeTemp = angular.copy(_.find(service.comparisonTypes, function (kv) {
      return kv.key === filter.comparisonType
          && filter.isNegativeMatch === kv.isNegativeMatch
          && (kv.forBulkTags || filter.valueList != undefined)
        && kv.forMultipleValues === !!filter.hasMultipleValues;
    }));

    if (!filter.comparisonTypeTemp) {
      filter.comparisonTypeTemp = angular.copy(service.defaultComparisonType);
    }
    return filter;
  }

  function getDefaultBulkTagComparison() {
    return angular.copy(_.find(_comparisonTypes, { value: 'EQUALS_SINGLE_VALUE' }));
  }

  function getMultipleBulkTagComparison() {
    return angular.copy(_.find(_comparisonTypes, { value: 'EQUALS_MULTIPLE_VALUES' }));
  }

  function getMultipleBulkTagComparisonSwitch(isNegativeMatch) {
    return isNegativeMatch ? angular.copy(_.find(_comparisonTypes, { value: 'DOES_NOT_EQUAL_MULTIPLE_VALUES' })) : angular.copy(_.find(_comparisonTypes, { value: 'EQUALS_MULTIPLE_VALUES' }));
  }

  function getGeoTagComparison() {
    return angular.copy(_.find(_comparisonTypes, { value: 'EQUALS', forGeoTags: true }));
  }

  function isBulkTagComparison(comparisonType) {
    const foundType = _.find(_comparisonTypes, { value: comparisonType, forBulkTags: true });
    return foundType && foundType.forMultipleValues;
  }

  function showDropdownValues(comparisonTypeKey) {
    return comparisonTypeKey && comparisonTypeKey.toLowerCase() === 'equals';
  }

}
